// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2omNv","right":"styles_right__2lXLY"};